import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';

const { baseUrl } = config;

export const sendOTP = async (userData) => {
  try {
    const url = `${baseUrl}/BioFuelRegistration/api/Registration/SendOTP`;

    console.log('sendOTP received userData:', userData);

    // Determine if it's phone or email based on login_through_enum
    const isPhone = userData.login_through_enum === 1;
    const isEmail = userData.login_through_enum === 2;

    const bodyParams = {
      user_name: userData.user_name || userData.phone || userData.email,
      login_through_enum: userData.login_through_enum || 1, // 1 for phone, 2 for email
      isResend: userData.isResend || false,
      access_method_type_enum: userData.access_method_type_enum || 2,
      log_id: userData.log_id || null,
      is_requested_number_change: userData.is_requested_number_change || false,
      person_id: userData.person_id || 0,
      agree: userData.agree || true,
      country_code: isEmail ? 0 : userData.country_code || 91, // 0 for email, 91 for phone
    };

    console.log('sendOTP bodyParams:', bodyParams);
    console.log('sendOTP user_name value:', bodyParams.user_name);
    console.log('sendOTP login_through_enum:', bodyParams.login_through_enum);
    console.log('sendOTP country_code:', bodyParams.country_code);

    const res = await utils.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
        initiator: 'rdDFSpr8gPjSX7VM',
      },
      body: JSON.stringify(bodyParams),
    }).ready;

    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-verification-sendOTP->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'SendOTP');
    throw errors;
  }
};

export const verifyOTP = async (otpData) => {
  try {
    const url = `${baseUrl}/BioFuelRegistration/api/Registration/VerifyOTP`;

    const bodyParams = {
      user_name: otpData.user_name,
      login_through_enum: otpData.login_through_enum || 1,
      otp: otpData.otp,
      log_id: otpData.log_id || null,
      login_user_id: null,
      access_method_type_enum: otpData.access_method_type_enum || 2,
      role_id: 1,
      person_id: null,
      login_through_enum_text: null,
      access_method_type_enum_text: null,
      authStep: 'signup-otp',
    };

    const res = await utils.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
        initiator: 'WSCnT79K0mCGjwTc',
      },
      body: JSON.stringify(bodyParams),
    }).ready;

    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-verification-verifyOTP->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'VerifyOTP');
    throw errors;
  }
};

export const sendEmailVerification = async (emailData) => {
  try {
    const url = `${baseUrl}/BioFuelRegistration/api/Registration/SendEmailVerification`;

    const bodyParams = {
      email: emailData.email,
      user_name: emailData.user_name,
      isResend: emailData.isResend || false,
      access_method_type_enum: emailData.access_method_type_enum || 2,
      log_id: emailData.log_id || null,
      person_id: emailData.person_id || 0,
    };

    const res = await utils.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
        initiator: 'rdDFSpr8gPjSX7VM',
      },
      body: JSON.stringify(bodyParams),
    }).ready;

    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-verification-sendEmailVerification->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'SendEmailVerification');
    throw errors;
  }
};

export const verifyEmail = async (emailVerificationData) => {
  try {
    const url = `${baseUrl}/BioFuelRegistration/api/Registration/VerifyEmail`;

    const bodyParams = {
      email: emailVerificationData.email,
      verification_token: emailVerificationData.verification_token,
      user_name: emailVerificationData.user_name,
      access_method_type_enum: emailVerificationData.access_method_type_enum || 2,
      log_id: emailVerificationData.log_id || null,
      person_id: emailVerificationData.person_id || 0,
    };

    const res = await utils.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
        initiator: 'rdDFSpr8gPjSX7VM',
      },
      body: JSON.stringify(bodyParams),
    }).ready;

    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-verification-verifyEmail->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'VerifyEmail');
    throw errors;
  }
};

export default {
  sendOTP,
  verifyOTP,
  sendEmailVerification,
  verifyEmail,
};
